import React from 'react';
import PropTypes from 'prop-types';
import { SFUpcomingAppt, SFNotification } from 'utils/types';
import css from './UpcomingList.css';
import UpcomingItem from './UpcomingItem';
import NoAppointments from './NoAppointments';
import { sortBy } from 'lodash';

export default class UpcomingList extends React.Component {

  get appointments() {
    // As of now we are handling only appointments
    const { appointments } = this.props.upcomingEvents;
    return appointments && appointments.length > 0
      ? sortBy(appointments, 'startDate')
        .map((item, i) =>
          <UpcomingItem
            key={i}
            timeZone={this.props.timeZone}
            getAppointments={this.props.getAppointments}
            notification={this.props.notification}
            {...item}
          />)
      : <NoAppointments />;
  }

  render() {
    return (
      <div className={css['container']}>
        {this.appointments}
      </div>
    );
  }
}

UpcomingList.propTypes = {
  upcomingEvents: PropTypes.shape({
    appointments: PropTypes.arrayOf(PropTypes.shape(SFUpcomingAppt))
  }).isRequired,
  timeZone: PropTypes.string,
  notification: SFNotification.isRequired,
  getAppointments: PropTypes.func.isRequired
};
